import styled from "styled-components";

export const Container = styled.div`
  background-color: rgba(200, 200, 200, 0.1);
  padding: 50px;
  margin: 20px;
  box-shadow: 0px 5px 10px rgba(200, 150, 150, 0.1);
`;
